<template>
  <div id="modal">
    <v-col>
      <v-form ref="form" v-model="valid">
        <v-row v-for="(i, index) in Object.keys(info)" :key="index">
          <date-picker
            v-if="i == 'fecha'"
            v-model="pickerDate"
            type="datetime"
            value-type="format"
            confirm
            confirm-text="Fijar fecha"
            :format="'DD/MM/YYYY HH:mm:ss'"
            :locale="locale"
            placeholder="Fecha"
            @change="setPickerDate(pickerDate)"
            :rules="[rules.required, rules.nulled]"
          ></date-picker>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            v-if="
              i != 'createdAt' &&
                i != 'updatedAt' &&
                i != 'id' &&
                i != 'id_material' &&
                i != 'id_role' &&
                i != 'id_user' &&
                i != 'id_ubicacion' &&
                i != 'id_proveedor' &&
                i != 'id_producto_ecommerce' &&
                i != 'material' &&
                i != 'ubicacion' &&
                i != 'proveedor' &&
                i != 'producto_ecommerce' &&
                i != 'user' &&
                i != 'role' &&
                i != 'fecha' &&
                i != 'password' &&
                i != 'lleno' &&
                i != 'habilitado' &&
                i != 'email' &&
                i != 'planta' &&
                i != 'zona' &&
                i != 'estanteria' &&
                i != 'balda' &&
                i != 'cantidad' &&
                i != 'precio' &&
                i != 'stock' &&
                i != 'codigo' &&
                i != 'role'
            "
            :rules="[rules.required, rules.nulled, rules.empty, rules.isNaN]"
          ></v-text-field>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            v-if="i == 'zona'"
            :rules="[
              rules.required,
              rules.nulled,
              rules.empty,
              rules.isNumber,
              rules.numberLimit
            ]"
          ></v-text-field>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            v-if="
              i == 'planta' ||
                i == 'estanteria' ||
                i == 'balda' ||
                i == 'cantidad' ||
                i == 'precio' ||
                i == 'stock'
            "
            :rules="[rules.required, rules.nulled, rules.empty, rules.isNumber]"
          ></v-text-field>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            v-if="i == 'codigo'"
            :rules="[rules.required, rules.nulled, rules.empty]"
          ></v-text-field>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            v-if="i == 'email'"
            :rules="[
              rules.required,
              rules.nulled,
              rules.empty,
              rules.validateEmail
            ]"
          ></v-text-field>

          <v-text-field
            v-model="info[i]"
            :label="camelize(i)"
            :type="hidePassword ? 'password' : 'text'"
            :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
            @click:append="hidePassword = !hidePassword"
            v-if="i == 'password'"
            :rules="[
              rules.required,
              rules.nulled,
              rules.empty,
              rules.passLength,
              rules.passCapitalLetter,
              rules.passLowCaseLetter,
              rules.passNumber,
              rules.passSpecialCharacter
            ]"
          ></v-text-field>

          <v-select
            v-if="i == 'role' && roles.length > 0"
            v-model="info.role"
            :items="roles"
            item-text="Rol de usuario"
            item-value="id"
            hint="Rol de Usuario"
            persistent-hint
            label="Rol de Usuario"
            return-object
            single-line
            hide-selected
            @change="changeIdRole()"
            :rules="[rules.required, rules.nulled]"
          ></v-select>

          <v-select
            v-if="i == 'material' && materiales.length > 0"
            v-model="info.material"
            :items="materiales"
            item-text="nombre"
            item-value="id"
            hint="Material"
            persistent-hint
            label="Material"
            return-object
            single-line
            hide-selected
            @change="changeIdMaterial()"
            :rules="[rules.required, rules.nulled]"
          ></v-select>

          <v-select
            v-if="i == 'proveedor' && proveedores.length > 0"
            v-model="info.proveedor"
            :items="proveedores"
            item-text="nombre"
            item-value="id"
            hint="Proveedor"
            persistent-hint
            label="Proveedor"
            return-object
            single-line
            hide-selected
            @change="changeIdProveedor()"
            :rules="[rules.required, rules.nulled]"
          ></v-select>

          <v-select
            v-if="i == 'ubicacion' && ubicaciones.length > 0"
            v-model="info.ubicacion"
            :items="ubicaciones"
            :item-text="getUbicacionText"
            item-value="id"
            hint="Código de ubicación"
            persistent-hint
            label="Código de ubicación"
            return-object
            single-line
            hide-selected
            @change="changeIdUbicacion()"
            :rules="[rules.required, rules.nulled]"
          >
          </v-select>

          <v-select
            v-if="i == 'producto_ecommerce' && productos_ecommerce.length > 0"
            v-model="info.producto_ecommerce"
            :items="productos_ecommerce"
            item-text="nombre"
            item-value="id"
            hint="Productos"
            persistent-hint
            label="Productos"
            return-object
            single-line
            hide-selected
            @change="changeIdProductoEcommerce()"
            :rules="[rules.required, rules.nulled]"
          >
          </v-select>

          <v-checkbox
            v-if="i == 'lleno' || i == 'habilitado'"
            color="#004283"
            v-model="info[i]"
            :label="i.toUpperCase()"
          ></v-checkbox>
        </v-row>
      </v-form>
    </v-col>
  </div>
</template>
<script>
import AlmacenService from "../../services/AlmacenService";
import UserService from "../../services/UserService";
export default {
  props: {
    info: Object,
    actualRol: String,
    element: String
  },
  async created() {
    if (this.info.id == undefined || this.info.id == null) {
      await this.setInfoFields();
    }
  },
  async mounted() {
    if (this.element == "Usuario") {
      this.roles = [];
      var arr = [];
      //SET ROLES
      var obj = await UserService.getRoles();
      arr = await obj.data[0];
      this.roles = arr;
      console.log(this.info);
      if (this.info.role == null) {
        this.info.role = this.roles[1];
        this.changeIdRole();
      }
    } else if (this.element == "Compra") {
      //SET FECHA
      this.pickerDate =
        this.info.fecha != null
          ? this.parseFecha(this.info.fecha)
          : this.parseFecha(new Date());

      this.materiales = [];
      var arr = [];
      //SET MATERIALES
      var obj = await AlmacenService.getAllMateriales();
      arr = await obj.data;
      this.materiales = arr;
      if (this.info.material == null) {
        this.info.material = this.materiales[0];
        this.changeIdMaterial();
      }
      //SET PROVEEDORES
      var obj3 = await AlmacenService.getAllProveedores();
      arr = await obj3.data;
      this.proveedores = arr;
      if (this.info.proveedor == null) {
        this.info.proveedor = this.proveedores[0];
        this.changeIdUbicacion();
      }
    } else if (this.element == "Ubicación") {
      this.pickerDate =
        this.info.fecha != null
          ? this.parseFecha(this.info.fecha)
          : this.parseFecha(new Date());
    } else if (this.element == "Material") {
      //SET UBICACIONES
      var obj2 = await AlmacenService.getAllUbicaciones();
      arr = await obj2.data;
      this.ubicaciones = arr;
      if (this.info.ubicacion == null) {
        this.info.ubicacion = this.ubicaciones[0];
        this.changeIdUbicacion();
      }
    } else if (this.element == "Compra Ecommerce") {
      //SET FECHA
      this.pickerDate =
        this.info.fecha != null
          ? this.parseFecha(this.info.fecha)
          : this.parseFecha(new Date());
      //SET UBICACIONES
      var obj2 = await AlmacenService.getAllProductos();
      arr = await obj2.data;
      this.productos_ecommerce = arr;
      if (this.info.producto_ecommerce == null) {
        this.info.producto_ecommerce = this.productos_ecommerce[0];
        this.changeIdProductoEcommerce();
      }
    }
  },
  data() {
    return {
      valid: true,
      show1: false,
      rol: null,
      users: [],
      materiales: [],
      proveedores: [],
      ubicaciones: [],
      productos_ecommerce: [],
      roles: [],
      pickerDate: null,
      hidePassword: true,
      locale: {
        weekdays: [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado"
        ],
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
        },
        rangeSeparator: " a ",
        time_24hr: true
      },
      rules: {
        required: value => !!value || "Campo requerido.",
        empty: value => value != "" || "Campo requerido.",
        nulled: value => value != null || "Campo requerido.",
        passLength: value =>
          (value.split("").length >= 8 && value.split("").length < 15) ||
          "La extensión de la contraseña deberá ser de entre 8 y 15 caracteres (ambos incluidos)",
        passCapitalLetter: value =>
          value.match(/.*[A-Z].*/) != null ||
          "La contraseña debe contener al menos una letra mayúscula",
        passLowCaseLetter: value =>
          value.match(/.*[a-z].*/) != null ||
          "La contraseña debe contener al menos una letra minúscula",
        passNumber: value =>
          value.match(/.*[0-9].*/) != null ||
          "La contraseña debe contener al menos un número",
        passSpecialCharacter: value =>
          "[`!@#$%^&*()_+-=[]{};':\"\\|,.<>/?~]"
            .split("")
            .some(sc => value.includes(sc)) ||
          "La contraseña debe contener al menos un caracter especial",
        isNumber: v =>
          (v != null &&
            !isNaN(
              v
                .toString()
                .replace(",", ".")
                .replace("±", "")
                .replace("&#177;", "")
                .replace("<", "")
                .replace(">", "")
                .replace("=", "")
                .replace("*", "")
                .replace("%", "")
                .replace("&#37", "")
            )) ||
          "Adjunte una expresión numérica",
        isNaN: v => isNaN(v) || "El campo no puede ser un número",
        numberLimit: v =>
          this.checkLimits(v, 1, 4) ||
          "El número debe estar comprendido entre 1 y 4",
        validateEmail: value =>
          value.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) != null || "Email inválido"
      }
    };
  },
  methods: {
    getUbicacionText: data => {
      var planta = "Planta: " + data.planta;
      var zona = "Zona: " + data.zona;
      var estant = "Estantería: " + data.estanteria;
      var balda = "Balda: " + data.balda;
      return (
        data.id +
        "- (" +
        planta +
        ", " +
        zona +
        ", " +
        estant +
        ", " +
        balda +
        ")"
      );
    },
    ver(c) {
      console.log(c);
    },
    checkLimits(value, min, max) {
      return min <= value && value <= max;
    },
    async validar() {
      this.valid = await this.$refs.form.validate();
      if (this.valid) return true;
      else return false;
    },
    changeIdRole() {
      if (this.info.role) {
        this.info.id_role = this.info.role.id;
      } else {
        this.info.id_role = null;
      }
    },
    changeIdUbicacion() {
      if (this.info.ubicacion) {
        this.info.id_ubicacion = this.info.ubicacion.id;
      } else {
        this.info.id_ubicacion = null;
      }
    },
    changeIdProductoEcommerce() {
      if (this.info.producto_ecommerce) {
        this.info.id_producto_ecommerce = this.info.producto_ecommerce.id;
      } else {
        this.info.id_producto_ecommerce = null;
      }
    },
    changeIdProveedor() {
      if (this.info.proveedor) {
        this.info.id_proveedor = this.info.proveedor.id;
      } else {
        this.info.id_proveedor = null;
      }
    },
    changeIdMaterial() {
      if (this.info.material) {
        this.info.id_material = this.info.material.id;
      } else {
        this.info.id_material = null;
      }
    },
    changeFecha() {
      this.info.fecha = this.pickerDate;
    },
    setInfoFields() {
      if (this.element == "Usuario") {
        this.info.username = "";
        this.info.nombre = "";
        this.info.email = "";
        this.info.password = "";
        this.info.role = null;
      } else if (this.element == "Material") {
        this.info.nombre = "";
        this.info.descripcion = "";
        this.info.stock = "";
        this.info.ubicacion = null;
      } else if (this.element == "Ubicación") {
        this.info.planta = "";
        this.info.zona = "";
        this.info.estanteria = "";
        this.info.balda = "";
        this.info.fecha = new Date();
        this.info.lleno = false;
      } else if (this.element == "Proveedor") {
        this.info.nombre = "";
        this.info.codigo = "";
        this.info.direccion = "";
        this.info.notas = "";
        this.info.habilitado = false;
      } else if (this.element == "Nota") {
        this.info.titulo = "";
        this.info.descripcion = "";
        this.info.id_user = this.$store.state.auth.user.id;
      } else if (this.element == "Compra") {
        this.info.fecha = new Date();
        this.info.codigo = "";
        this.info.cantidad = "";
        this.info.precio = "";
        this.info.id_material = null;
        this.info.id_ubicacion = null;
        this.info.id_proveedor = null;
        this.info.material = null;
        this.info.proveedor = null;
      } else if (this.element == "Producto Ecommerce") {
        this.info.nombre = "";
        this.info.unidad = "";
      } else if (this.element == "Compra Ecommerce") {
        this.info.codigo = "";
        this.info.fecha = new Date();
        this.info.id_producto_ecommerce = null;
        this.info.producto_ecommerce = null;
      }
    },
    camelize(str) {
      var c = str.charAt(0).toUpperCase() + str.slice(1);
      var final = "";
      var arr = c.split("_");
      arr.forEach((e, i) => {
        if (i < arr.length) {
          final += e + " ";
        } else {
          final += e;
        }
      });
      return final;
    },
    getActualRole() {
      return this.actualRol;
    },
    capitalizeFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    lowerFirst(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    setPickerDate(value) {
      this.info.fecha = this.toDBFecha(value);
    },
    toDBFecha(value) {
      var dia = value.substr(0, 2);
      var mes = value.substr(3, 2);
      var year = value.substr(6, 4);
      var half = year + "-" + mes + "-" + dia + "T";
      var hour = value.substr(11, 2);
      var min = value.substr(14, 2);
      var sec = value.substr(17, 2);
      var half2 = hour + ":" + min + ":" + sec + ".000Z";
      var final = half + half2;
      return final;
    },
    parseFecha(fecha) {
      var m = new Date();
      if (fecha == null) {
        return this.sliceDate(m);
      }
      m = new Date(fecha);
      return this.sliceDate(m);
    },
    sliceDate(m) {
      var hh = m.getHours();
      var mins = m.getMinutes();
      var secs = m.getSeconds();
      var hourtime = [
        (hh > 9 ? "" : "0") + hh,
        (mins > 9 ? "" : "0") + mins,
        (secs > 9 ? "" : "0") + secs
      ].join(":");
      var nf =
        ("0" + m.getUTCDate()).slice(-2) +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        m.getUTCFullYear() +
        " " +
        hourtime;
      return nf;
    }
  }
};
</script>
<style scoped>
h5 {
  color: #004283;
}
.tableFlex {
  width: 50%;
}
.v-card {
  padding: 1em;
  margin-bottom: 0.8em;
}

#areas {
  margin-top: 0.35em;
  margin-bottom: 0.85em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/OptionalModals.vue